import React from 'react';


export class Header extends React.Component {
    render() {
        return (
            <div className="gcm-m-header">
                <img src="/assets/images/med_logo.png" className="gcm-m-header-logo" />
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// frontend/src/modules/mobile/components/Header.jsx